import { render, staticRenderFns } from "./5.vue?vue&type=template&id=7b63437a&scoped=true"
import script from "./5.vue?vue&type=script&lang=js"
export * from "./5.vue?vue&type=script&lang=js"
import style0 from "./5.vue?vue&type=style&index=0&id=7b63437a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b63437a",
  null
  
)

export default component.exports